import React from 'react';
import BasicChart from './BasicColumn'
import BasicChartMgr from './BasicColumnMgr'
import PieChart from './Piechart'
import PieChartMgr from './BrookPiechartMgr'
import BrookPiechart from './BrookPiechart '
import NewYorkPiechart from './NewYorkPiechart'
import OrlandoPiechart from './OrlandoPiechart'
import BasicColumnPay from './BasicColumnPay';
import BasicColumnPayMgr from './BasicColumnPayMgr';
import jwt_decode from 'jwt-decode';

const ChartList = () => {
    return (
        <div>
            {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).branch_code : '' ) === 'ALL'  &&   
            <div>
                <h3>Monthly donations/Location</h3>
                <BasicChart   />
                <h3>Monthly payments/Location</h3>
                <BasicColumnPay />
                <h3>Unit status</h3>
                <PieChart />
                <OrlandoPiechart/>
                <NewYorkPiechart />
                <BrookPiechart />
            </div>
            }
            {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).branch_code : '' ) !== 'ALL' &&
            <div>
            <h3>Monthly donations at {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).location : '' )}</h3>
                <BasicChartMgr   />
                <h3>Monthly payments at {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).location : 'Orlando' )}</h3>
                <BasicColumnPayMgr />
                <h3>Unit status at {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).location : 'Orlando' )}</h3>
                <PieChartMgr />
            </div>
            }
        </div>
  )
}

export default ChartList